import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Placement } from '@popperjs/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'floating-panel',
  templateUrl: './floating-panel.component.html',
  styleUrls: ['./floating-panel.component.scss']
})
export class FloatingPanelComponent {
  placements: Placement[] = [
    'auto', 'top', 'bottom', 'right', 'left', 'bottom-end', 'bottom-start', 'top-end', 'top-start'
  ];
  inputNgModelNojs: string = ''
  dropdownOptions = [
    { label: 'Option 1', value: 'Option 1' },
    { label: 'Option 2', value: 'Option 2' },
    { label: 'Option 3', value: 'Option 3' },
    { label: 'Option 4', value: 'Option 4' },
  ];

  buttonList = [
    { id: 'clearAll',
      name: 'clearAll',
      label: 'Clear',
      url: '/floating-panel',
      hasClearButton:true,
      disabled: false,
      queryParams:''
    },
    { id: 'apply',
    name: 'apply',
    label: 'Apply',
    url: '/floating-panel',
    hasApplyButton:true,
    disabled: false,
    queryParams:''
  }
  ];
  language = 'Option 1';
  selectedPlacement: Placement = 'auto';
  languages: string[] = [
    'English', 'Spanish', 'Hindi'
  ];
  useCase = 'SimpleFloatingPanel';
  selectedUseCase = 'SimpleFloatingPanel';
  useCases: string[] = [
    'SimpleFloatingPanel', 'PenTool', 'HighlightTool', 'TypeTool', 'PopoverListWithZeroPadding', 'PopoverListWith16pxPaddingWithScrollbar', 'PopoverListWith24pxPadding'
  ];
  selectedLanguage: string = 'English';
  hasCloseButton: boolean = false;
  hasBackdrop: boolean = true;
  hasCaret: boolean = false;

  penStroke = "1";
  penColor = "#fff";
  highlightStroke = "2";
  highlightColor = "#AC7BDF";
  textFontValue = "12";
  textColor = "#000";
  textBackgroundColor = "#fff";

  // listItems: List[] = [];
  // listItems2: List[] = [];
  // listItems3: List[] = [];
  listId = "ListContainer1";
  showVeritcal: boolean = false;
  showHorizontal: boolean = true;
  isBrowser = true;

  colorList: any = [
    { name: 'white', color: '#fff', isDisabled: false },
    { name: 'gray', color: '#888', isDisabled: false },
    { name: 'black', color: '#000', isDisabled: false },
    { name: 'yellow', color: '#ffef7e', isDisabled: false },
    { name: 'orange', color: '#ff9900', isDisabled: false },
    { name: 'brown', color: '#b26b00', isDisabled: false },
    { name: 'red', color: '#e60000', isDisabled: false },
    { name: 'pink', color: '#f06666', isDisabled: false },
    { name: 'violet', color: '#9933ff', isDisabled: false },
    { name: 'blue', color: '#0066cc', isDisabled: false },
    { name: 'sky', color: '#66a3e0', isDisabled: false },
    { name: 'green', color: '#008a00', isDisabled: false }
  ];

  penTypeSize: any = [
    { strokeType: 'small', strokeSize: "1", isDisabled: false },
    { strokeType: 'medium', strokeSize: "2", isDisabled: false },
    { strokeType: 'large', strokeSize: "3", isDisabled: false },
    { strokeType: 'extra-large', strokeSize: "4", isDisabled: true }
  ];

  highlightColorList: any = [
    { name: 'purple', color: '#AC7BDF', isDisabled: false },
    { name: 'pink', color: '#FEA3CE', isDisabled: false },
    { name: 'green', color: '#9FFE84', isDisabled: false },
    { name: 'yellow', color: '#FFEF7E', isDisabled: false },
    { name: 'cyan', color: '#80F8F4', isDisabled: false },
    { name: 'orange', color: '#FEB97A', isDisabled: false }
  ];

  highlightStrokeSize: any = [
    { strokeType: 'small', strokeSize: "2", isDisabled: false },
    { strokeType: 'medium', strokeSize: "4", isDisabled: false },
    { strokeType: 'large', strokeSize: "6", isDisabled: false },
    { strokeType: 'extra-large', strokeSize: "8", isDisabled: true }
  ];

  textFontSize: any = [
    { fontType: 'small', fontSize: "12", isDisabled: false },
    { fontType: 'medium', fontSize: "14", isDisabled: false },
    { fontType: 'large', fontSize: "16", isDisabled: false },
    { fontType: 'extra-large', fontSize: "18", isDisabled: true }
  ];

  typeColorList: any = [
    { name: 'white', color: '#fff', isDisabled: false },
    { name: 'gray', color: '#888', isDisabled: false },
    { name: 'black', color: '#000', isDisabled: false },
    { name: 'yellow', color: '#ffef7e', isDisabled: false },
    { name: 'orange', color: '#ff9900', isDisabled: false },
    { name: 'brown', color: '#b26b00', isDisabled: false },
    { name: 'red', color: '#e60000', isDisabled: false },
    { name: 'pink', color: '#f06666', isDisabled: false },
    { name: 'violet', color: '#9933ff', isDisabled: false },
    { name: 'blue', color: '#0066cc', isDisabled: false },
    { name: 'sky', color: '#66a3e0', isDisabled: false },
    { name: 'green', color: '#008a00', isDisabled: false }
  ];

  typeToolList = [
    {
      title: 'Text Color',
      type: 'text',
      isDisable: false,
      colorlist: this.typeColorList
    },
    {
      title: 'Background',
      type: 'background',
      isDisable: false,
      colorlist: this.typeColorList
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private _activatedRoute: ActivatedRoute
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this._activatedRoute.queryParams.subscribe(param => {
      if (param['language']) {
        this.inputNgModelNojs = param['language'];
      }
    });
  }

  buttonFocus(value:string){
      if(document.getElementById(value)){
        document.getElementById(value)?.focus();
      } 
  }

  
  onPenSizeSelection(value: any) {
    this.penStroke = value;
  }

  onPenColorSelection(value: any) {
    this.penColor = value;
  }

  onHighlightSelection(value: any) {
    this.highlightStroke = value;
  }

  onHighlightColorSelection(value: any) {
    this.highlightColor = value;
  }

  ontextFontSelection(value: any) {
    this.textFontValue = value;
  }

  onTextColorSelection(value: any) {
    this.textColor = value;
  }

  onTextBackgroundSelection(value: any) {
    this.textBackgroundColor = value;
  }
}